import {StoreIconType} from '../../../../shared/entity_datas/StoreEnums'
import {UIAjaxWrapper} from '../network/UIAjaxWrapper'
import {UIAPIEndpoints} from '../network/UIAPIEndpoints'
import {PlayerColor} from '@colonist/game-states'

export class ProfileEditAjaxEndPoints {
    private static readonly contentType = 'application/json'

    static async updateUsername(newUsername: string, shouldPurchaseIfNoAttemptsLeft: boolean = false): Promise <boolean> {
        const urlVariable = 'username'
        const data = {username: newUsername, shouldPurchaseIfNoAttemptsLeft: shouldPurchaseIfNoAttemptsLeft}
        return this.updateProfile(urlVariable, data)
    }

    static async updatePreferredColor(preferredColor: PlayerColor) {
        const urlVariable = 'preferred-color'
        const data = {preferredColor: preferredColor}
        await this.updateProfile(urlVariable, data)
    }

    static async updateIcon(icon: StoreIconType) {
        const urlVariable = 'icon'
        const data = {icon: icon}
        await this.updateProfile(urlVariable, data)
    }

    private static async updateProfile(urlVariable: string, data: any): Promise<boolean> {
        const response = await UIAjaxWrapper.postRequestHandler(`${UIAPIEndpoints.apiUpdateProfile()}/${urlVariable}`, undefined, data, this.contentType)
        if(response == undefined) return false
        return true
    }
}
